module.exports = __webpack_public_path__ + "7688be75dd5473f1f52d16e9599903e0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/atom.png
// module id = 2808
// module chunks = 0